import { GoogleSSOModel } from 'api/models';
import axios from 'axios';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

export const getGoogleSSOAuthUrl = async () => {
    const { data } = await axios.get<{ authUrl: string }>(`${getApiUrl()}/sso/google/auth-url`);

    return data;
};

export const getGoogleSSO = async () => {
    const { data } = await http.get(`${getApiUrl()}/sso/google`);

    return data ? GoogleSSOModel.fromObject(data) : null;
};

export const authorizeGoogle = async (payload: { code: string; redirectUri: string }) => {
    const { data } = await http.post(`${getApiUrl()}/sso/google/authorize`, {
        code: payload.code,
        redirectUri: payload.redirectUri,
    });

    return GoogleSSOModel.fromObject(data);
};

export const unauthorizeGoogle = async () => {
    await http.delete(`${getApiUrl()}/sso/google/unauthorize`);
};

export const authenticateGoogle = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/google/authenticate`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });

        return data as {
            token: string;
            hasMultipleAccounts: boolean;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};

export const onBoardingAuthenticateGoogle = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/google/user-info`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });

        return data as {
            id: string;
            email: string;
            name: string;
            dp: string;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};
